<template>
    <div class="prize-container" v-show="loaded">
        <inner-children-renderer v-if="_child" :children="_child" />
    </div>
</template>

<script>
import Vue from 'vue';

const {
    plugins: { ComplexComp },
    common: {
        env: { isPreRender }
    },
    store: { variable }
} = require('@futuweb/fego-render');

import ChildItem from '../children/item/render/index.vue';
import { CHILD } from '../constant';
import request from '../assets/scripts/request';

import { PRIZE_SEARCH_TYPE } from '../constant';

export default Vue.extend({
    name: 'prize-container',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl'],

    data() {
        return {
            loaded: false,
            defaultTargetId: this.tpl.children.find((c) => c.props?.isDefault)?.id,
            targetId: '',
            v: variable.data,
            loading: false
        };
    },

    computed: {
        isLogin() {
            return !!this.v.UID;
        },
        _child() {
            if (!this.loaded) {
                return null;
            }

            let r = this.tpl.children.find((c) => c?.id === this.targetId);
            if (!r) {
                r = this.tpl.children.find((c) => c?.id === this.defaultTargetId);
            }

            return r;
        }
    },

    async mounted() {
        if (isPreRender) {
            return;
        }
        await this.refresh(true);
        this.loaded = true;
    },

    methods: {
        async refresh(init = false) {
            // 防重复点击
            if (this.loading) {
                return;
            }
            this.loading = true;

            // 保留上一个状态
            const lastTarget = this.targetId;
            let targetId = '';
            try {
                targetId = await this.getStatus();
            } catch (err) {
                console.error('[prize-container] getStatus error: ', err);
            } finally {
                this.loading = false;
            }

            if (!targetId) {
                // 主动刷新的情况下，如果失败，优先取原来状态
                targetId = (!init && lastTarget) || this.defaultTargetId;
            }
            this.targetId = targetId;
        },

        async getStatus() {
            // 未登录
            if (!this.isLogin) {
                return null;
            }

            // 参数不对
            const testBusinessId = this._getTestBusinessId() || 0;
            const businessId = this._getBusinessId();
            const targets = this._getTargets();
            if (!businessId) {
                throw new Error('businessId is required');
            }
            if (!targets || !targets.length) {
                throw new Error('children is required');
            }

            const commonApiRequest = request.bindCommonApi('prize-container');
            const r = await commonApiRequest.post(
                'getStatus',
                {
                    businessId,
                    testBusinessId,
                    targets
                },
                {
                    // 不需要限制请求频次
                    group: null
                }
            );
            return r;
        },

        _getTestBusinessId() {
            return +this.tpl.props.testBusinessId;
        },

        _getBusinessId() {
            return +this.tpl.props.businessId;
        },

        _getTargets() {
            return (
                this.tpl.children
                    // 过滤掉默认状态
                    .filter((c) => !c?.props?.isDefault)
                    // 处理数据
                    .map((c) => {
                        let data = {
                            id: c.id,
                            searchType: c.props.searchType
                        };
                        if (data.searchType === PRIZE_SEARCH_TYPE.ByRule) {
                            data = {
                                ...data,
                                ruleId: c.props.ruleId,
                                subRuleId: c.props.subRuleId
                            };
                        } else {
                            data = {
                                ...data,
                                prizeId: c.props.prizeId,
                                awardId: c.props.awardId
                            };
                        }
                        return data;
                    })
            );
        }
    }
});
</script>

<style lang="less" scoped>
.prize-container {
    height: auto !important;
}
</style>
